module.exports = __webpack_public_path__ + "static/media/1 0 Orddiktat Intro.350b9b86.mp3";